var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3438 19.3281L15.3047 14.2891C15.2266 14.2109 15.1094 14.1719 14.9922 14.1719H14.5625C15.9297 12.6875 16.75 10.7734 16.75 8.625C16.75 4.17188 13.0781 0.5 8.625 0.5C4.13281 0.5 0.5 4.17188 0.5 8.625C0.5 13.1172 4.13281 16.75 8.625 16.75C10.7344 16.75 12.6875 15.9297 14.1328 14.6016V14.9922C14.1328 15.1484 14.1719 15.2656 14.25 15.3438L19.2891 20.3828C19.4844 20.5781 19.7578 20.5781 19.9531 20.3828L20.3438 19.9922C20.5391 19.7969 20.5391 19.5234 20.3438 19.3281ZM8.625 15.5C4.79688 15.5 1.75 12.4531 1.75 8.625C1.75 4.83594 4.79688 1.75 8.625 1.75C12.4141 1.75 15.5 4.83594 15.5 8.625C15.5 12.4531 12.4141 15.5 8.625 15.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b7e50d53.svg";
export { ForwardRef as ReactComponent };